export const DefaultJustification = 3;
export const DefaultFontWidth = 5;
export const DefaultFontHeight = 7;

export enum LineAlignment {
    Left = 2,
    Center = 3,
    Right = 4,
}

export enum PhaseAlignment {
    Top = 2,
    Middle = 3,
    Bottom = 4
}